import ProdutoService from '@/services/produto.service'

export default {
  namespaced: true,
  state: {
    produto: null,
    produtos: [],
    loading: false,
    error: null,
  },
  mutations: {
    setLoading: (state, loading) => state.loading = loading,
    setError: (state, error) => state.error = error,
    setProdutos: (state, produtos) => state.produtos = produtos,
    setProduto: (state, produto) => state.produto = produto,
  },
  actions: {
    ['resetProdutos']({ commit }) {
      commit('setProdutos', [])
    },
    async ['buscaProduto']({ commit },
      {
        uf,
        operadora,
        tipo_plano,
        contratacao,
        cidade,
        compulsorio,
        coparticipacao,
        acomodacao,
        regras_aceitacao,
        credenciado,
        entidade,
        profissao,
        faixas,
        grupos_faixas,
        mei
      }
    ) {
      console.log('buscaProduto')
      try {
        commit('setLoading', true)
        const data = await ProdutoService.busca(
          uf,
          operadora,
          tipo_plano,
          contratacao,
          cidade,
          compulsorio,
          coparticipacao,
          acomodacao,
          regras_aceitacao,
          credenciado,
          entidade,
          profissao,
          faixas,
          grupos_faixas,
          mei
        )
        commit('setProdutos', data)
      } catch (error) {
        commit('setError', error)
      } finally {
        commit('setLoading', false)
      }
    }
  },
  getters: {
    getLoading: state => state.loading,
    getError: state => state.error,
    getProduto: state => state.produto,
    getProdutos: state => state.produtos,
  }
}
